
export const documentValidation =(uint8Array)=>{

    // Look for the `/Encrypt` marker in the PDF content
    const textContent = new TextDecoder().decode(uint8Array);
    const isEncrypted = textContent.includes('/Encrypt');

    if (isEncrypted) {
      return false
    } else {
      return true
    }
}
export const areNamesUnique =(statefile,dropFile) => {
  const isWithoutDuplicate = statefile.map(item => {
    return dropFile.findIndex(each => each.name==item.name) < 0 ? true : false
   })
  return isWithoutDuplicate.every(value => value===true)
}


export const fileSizeValidation = (statefile,dropFile)=>{ 
  let deepCopy = [...statefile,...dropFile];
   let totalDropFile = deepCopy.reduce((total,value) =>total + value.size,0)
          if(totalDropFile > 15728640){
              return false
          }else{
            return true
          }

}